import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/overview/…` → `/{store}/overview/…`. */
export const Route = createFileRoute("/overview/$")({ beforeLoad: redirectIntoScope });
